import { render, staticRenderFns } from "./SafetyConfirmList.vue?vue&type=template&id=3a96c667&scoped=true&lang=pug"
import script from "./SafetyConfirmList.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmList.vue?vue&type=script&lang=ts"
import style0 from "./SafetyConfirmList.vue?vue&type=style&index=0&id=3a96c667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96c667",
  null
  
)

export default component.exports